import React, { useState } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import WebTopbar from '../../components/topbar/WebTopbar';
import { TOPBAR_HEIGHT } from '../../constants/layout';
import IdealCustomerStep from '../../components/onboarding/IdealCustomerStep';
import { saveOnboardingSignals } from '../../api/onboarding';
import type { ICPAccount } from '../../api/onboarding';
import { toOnboardingSignalsSaveRequest } from '../../components/onboarding/onboardingSaveRequest';
import { useSnackbar } from '../../context/SnackbarContext';

export const OnboardingPage: React.FC = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [finishingOnboarding, setFinishingOnboarding] = useState(false);

  const handleOnboardingComplete = async (result: {
    accounts: ICPAccount[];
    signalInstructions: string[];
    prioritizationValidatedMessage: string;
  }) => {
    if (!result.accounts.length || finishingOnboarding) {
      if (!result.accounts.length) {
        showSnackbar('Add suggested companies first.', 'error');
      }
      return;
    }
    setFinishingOnboarding(true);
    try {
      const body = toOnboardingSignalsSaveRequest({
        companies: result.accounts,
        signalInstructions: result.signalInstructions,
        prioritizationValidatedMessage: result.prioritizationValidatedMessage
      });
      const campaign = await saveOnboardingSignals(body);
      navigate(`/campaign/${campaign.id}`, {
        state: { openPrioritization: true }
      });
    } catch (err) {
      const message =
        err instanceof Error ? err.message : 'Something went wrong. Try again.';
      showSnackbar(message, 'error');
    } finally {
      setFinishingOnboarding(false);
    }
  };

  return (
    <>
      <WebTopbar />
      <Box
        component="main"
        sx={{
          minHeight: `calc(100vh - ${TOPBAR_HEIGHT}px)`,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
          pt: 6,
          px: 2,
          pb: 4,
          backgroundColor: '#f5f5f5'
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: 640,
            backgroundColor: 'white',
            borderRadius: 1,
            boxShadow: 1,
            p: 4
          }}
        >
          <IdealCustomerStep
            onComplete={(r) => void handleOnboardingComplete(r)}
            isSubmitting={finishingOnboarding}
          />
        </Box>
      </Box>
    </>
  );
};

export default OnboardingPage;
